import { rollbar } from "@/utils/rollbar"

const languageData = import.meta.glob("./**/*.json")

export default class backend {
  static type = "backend" as const

  read = async (
    language: "en" | "nl",
    namespace: string,
    callback: (err: Error | null, data: unknown | null) => void
  ) => {
    let data: unknown = null
    const fileLocation = `./${language}/${namespace}.json`
    try {
      data = await languageData[fileLocation]()
    } catch (error) {
      rollbar.error(error as Error)
      console.error(`Error loading language data: ${fileLocation}`)
      return callback(error as Error, data)
    }
    callback(null, data)
  }
}

backend.type = "backend"
